import type { FaireProductEntity } from "../../entity_types/product";

export const p_s6sz89vhx5: FaireProductEntity = {
  token: "p_s6sz89vhx5",
  type: "product",
  name: "TRIPLE DOUBLE",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/60a60cef4aabd578d31cd5c3c5a52f9808938e7aad2055d261888235b31b7f71.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/544804f22e592f15cd15ed0f3b581173e735a54f588c2e2eb8ec37dc4e9ad66c.png",
    "https://cdn.faire.com/fastly/f7985db10b4778f6310ce06c907fc552b5088d5b6bac3516b9300c4e67270c1b.png",
    "https://cdn.faire.com/fastly/604d702107bbdcf37f9d29b8527ce667fef8587ae070a73d1c1d9755df46b459.png",
  ],
  priceDollars: 14.4,
  description:
    "Tasting Notes: Strawberry, cherry, & lime\n\nLocation: Andes, Antioquia, Colombia\n\nAltitude: 1800 - 2000 masl\n\nVariety: Castillo, Colombia and Caturra\n\nProcess: Natural\n\nRoast Level: Light to Medium\n\nRecommended Brew: Pour-over, drip, or AeroPress\n\nAbout the Coffee: \n\nThe Triple Double: The Triple Double is an extension of our Double Double. The Triple Double is a new coffee that packs Triple the flavor and double the purpose. This coffee is the latest Development Lot by Unblended Coffee, a collaboration lot that is a risk-free avenue to develop the profiles of young coffee producers. This is one of those coffees that creates more purpose and fosters collaborations between producers, consumers, and roasters like ourselves.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:10.209Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
